import { LeftOutlined } from '@ant-design/icons';
import { getUser } from '@app/api/users.api';
import { Card } from '@app/components/common/Card/Card';
import { notificationController } from '@app/controllers/notificationController';
import { useAppDispatch, useAppSelector } from '@app/hooks/reduxHooks';
import { useResponsive } from '@app/hooks/useResponsive';
import { setClient, setUserDetails } from '@app/store/slices/userSlice';
import { getUserRouteInfo } from '@app/utils/utils';
import { Col, Row } from 'antd';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { WorkerInfo } from './workerCard/WorkerInfo/WorkerInfo';
import { WorkerNav } from './workerCard/WorkerNav/WorkerNav';
import * as S from './WorkerLayout.styles';

const ClientLayout: React.FC = () => {
  const user = useAppSelector((state) => state.user.client);
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const { baseSlug, isAdmin } = getUserRouteInfo(location);

  const dispatch = useAppDispatch();

  const getTitle = () => {
    return id ? t(`${baseSlug}.form.updateTitle`) : t(`${baseSlug}.form.addTitle`);
  };

  const { t } = useTranslation();
  const { isTablet: isTabletOrHigher, mobileOnly } = useResponsive();
  const navigate = useNavigate();

  const isTitleShown = isTabletOrHigher || (mobileOnly && location.pathname === `/${baseSlug}`);

  useEffect(() => {
    async function fetchClient() {
      if (id) {
        try {
          const client = await getUser(id);
          setUserDetails(client, dispatch, true);
        } catch (error) {
          notificationController.error({ message: (error as Error).message });
        }
      }
    }

    fetchClient();

    return () => {
      dispatch(setClient(null));
    };
  }, [dispatch, id]);

  return (
    <>
      {!isTitleShown && (
        <S.Btn icon={<LeftOutlined />} type="text" onClick={() => navigate(`/${baseSlug}`)}>
          {t('common.back')}
        </S.Btn>
      )}
      <Card title={getTitle()} padding="1.25rem">
        <Row gutter={[30, 30]}>
          <Col xs={24} md={24} xl={8}>
            <S.ProfileCard>
              <Row gutter={[30, 30]}>
                <Col xs={24} md={12} xl={24}>
                  <WorkerInfo profileData={user} baseSlug={baseSlug} />
                </Col>

                <Col xs={24} md={12} xl={24}>
                  <WorkerNav baseSlug={baseSlug} isAdmin={isAdmin} />
                </Col>
              </Row>
            </S.ProfileCard>
          </Col>
          <Col xs={24} md={24} xl={16}>
            <Outlet />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default ClientLayout;
